
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

// The ID of the user whose settings will be used as default
const DEFAULT_USER_ID = 'fdd34a43-dc5e-4374-8282-099bc4242591';

/**
 * Fetches settings from a specific user to use as default settings
 */
export const fetchDefaultSettings = async () => {
  try {
    // Using the exact query provided by the user
    const { data, error } = await supabase.rpc('get_all_user_data', {
      p_user_id: DEFAULT_USER_ID
    });

    if (error) {
      console.error("Error fetching default settings:", error);
      toast({
        variant: "destructive",
        title: "Error loading default settings",
        description: "Could not load default settings. Using system defaults instead."
      });
      return null;
    }

    if (!data || data.length === 0) {
      console.log("No default settings found for the specified user");
      return null;
    }

    return data;
  } catch (error) {
    console.error("Exception fetching default settings:", error);
    return null;
  }
};

/**
 * Fetches default prayer times from a specific user
 */
export const fetchDefaultPrayerTimes = async () => {
  try {
    const { data, error } = await supabase
      .from('times')
      .select('*')
      .eq('user_id', DEFAULT_USER_ID);

    if (error) {
      console.error("Error fetching default prayer times:", error);
      return null;
    }

    if (!data || data.length === 0) {
      console.log("No default prayer times found for the specified user");
      return null;
    }

    return data;
  } catch (error) {
    console.error("Exception fetching default prayer times:", error);
    return null;
  }
};
